import { Selector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'

export const errorSelector: Selector<ReduxState, string | undefined> = state => state.processingCosts.UIState.error
export default errorSelector